import { render, staticRenderFns } from "./DocsDetailExample.vue?vue&type=template&id=1128be22&"
import script from "./DocsDetailExample.vue?vue&type=script&lang=js&"
export * from "./DocsDetailExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports